import moment from 'moment-timezone';

export const USER_DEVICE_ZONE = Object.freeze(moment.tz.guess());

export const mappingTimezone = (tz) => {
  switch (tz) {
    case '-3.5':
      return 'Canada/Newfoundland';
    case '-4':
      return 'Canada/Atlantic';
    case '-5':
      return 'Canada/Eastern';
    case '-6':
      return 'Canada/Central';
    case '-7':
      return 'Canada/Mountain';
    case '-8':
      return 'Canada/Pacific';
    case '-9':
      return 'US/Alaska';
    case '-10':
      return 'US/Aleutian';
    case '+7':
      return 'Asia/Ho_Chi_Minh';
    default:
      return tz;
  }
};

export const mappingTimezoneToOffset = (tz) => {
  const timezone = moment().tz(mappingTimezone(tz)).utcOffset() / 60;

  return timezone;
};

export const getDeviceTime = () => moment().tz(USER_DEVICE_ZONE);

export const convertTimeTzToLocaltime = (timeWithTimezone) =>
  moment(timeWithTimezone);
export const makeMomentWithLocalTz = (datetime, inputFormat) =>
  moment(datetime, inputFormat);

export const formatTimeString = (timeString) =>
  typeof timeString === 'string'
    ? timeString.replace('AM', 'a.m').replace('PM', 'p.m')
    : '';

// This function will work incorrect if local time include timezone
export const convertDateToMomentWithTz = (
  localTime,
  formatLocalTime = 'MM/DD/YYYY',
  timeZone = 'America/Vancouver',
) => {
  const convertTime = moment(localTime, formatLocalTime);
  return moment().tz(timeZone).set({
    year: convertTime.year,
    month: convertTime.month,
    date: convertTime.date,
    hour: 0,
    minute: 0,
    second: 0,
  });
};

export const makeTodayMomentWithTz = (timeZone) => {
  if (timeZone) {
    return moment().tz(timeZone);
  }
  return moment();
};

// TODO: Re-check again
export const convertTime = (time, format = 'L') => moment(time).format(format);
export const getSimpleDate = (date, format) =>
  date ? moment(date).format(format || 'YYYY-MM-DDTHH:mm:ss') : null;
export const getStartOfDay = (date) => moment(date).startOf('day');
export const getEndOfDay = (date) => moment(date).endOf('day');
export const convertH2M = (timeInHour) => {
  if (!timeInHour) return null;
  const timeParts = timeInHour.split(':');
  return Number(timeParts[0]) * 60 + Number(timeParts[1]);
};
